export default __webpack_public_path__ + "static/media/verified.12f153d5.png";